import React from "react";
import { Title } from "react-admin";
import { Route } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { orange, amber, grey, green } from "@material-ui/core/colors";
import OutboundShipmentCardContainer from "./ProcessShipmentsCard";
import { OutboundProvider } from "./context";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { ProcessOutboundShipmentList } from "./ProcessOutboundShipmentList";

const useStyles = makeStyles((theme) => ({
  summaryContainer: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(2),
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
  },
  progress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 300,
  },
  button: {
    margin: theme.spacing(1),
  },
  settings: {
    marginTop: theme.spacing(2),
  },
  orange: {
    color: theme.palette.getContrastText(orange[100]),
    backgroundColor: orange[100],
  },
  green: {
    color: theme.palette.getContrastText(green[200]),
    backgroundColor: green[200],
  },
  amber: {
    color: theme.palette.getContrastText(amber[500]),
    backgroundColor: amber[500],
  },
  unprocessedItem: {
    color: theme.palette.getContrastText(grey[300]),
    backgroundColor: grey[300],
  },
  backToInventory: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(4),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
  listAuditProgress: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  inventoriesSection: {
    marginTop: theme.spacing(2),
  },
  photo: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
  photoContainer: {
    display: "flex",
    alignItems: "center",
  },
  link: {
    color: "inherit",
    textDecoration: "inherit",
  },
  searchField: {
    marginLeft: theme.spacing(1),
  },
  shipmentFilter: {
    marginRight: theme.spacing(2),
  },
  photoErrorSection: {
    paddingLeft: theme.spacing(2),
  },
  notFound: {
    display: "fles",
    margin: theme.spacing(2),
  },
  finishButton: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
  },
  topActions: {
    paddingTop: theme.spacing(2),
  },
}));

const ProcessOutboundShipments = (props) => {
  const classes = useStyles();

  return (
    <OutboundProvider>
      <Title title={<ForceTitle title="Outbounds" />} />
      <Route
        path={`${props.match.path}`}
        exact
        render={(props) => (
          <ProcessOutboundShipmentList classes={classes} {...props} />
        )}
      />
      <Route
        path={`${props.match.path}/:id`}
        render={(props) => (
          <OutboundShipmentCardContainer classes={classes} {...props} />
        )}
      />
    </OutboundProvider>
  );
};

export default ProcessOutboundShipments;
